module.exports = __webpack_public_path__ + "amcharts/images/dragIconBlack.gif";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconBlack.gif
// module id = 227
// module chunks = 0